import { render } from "./DocEdit.vue?vue&type=template&id=649634d6&scoped=true&ts=true"
import script from "./DocEdit.vue?vue&type=script&lang=ts"
export * from "./DocEdit.vue?vue&type=script&lang=ts"

import "./DocEdit.vue?vue&type=style&index=0&id=649634d6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649634d6"]])

export default __exports__